<template>
  <div>
    <files-uploader
      v-model="auditDTO.auditAnnouncement"
      :name-folder="String(audit.id)"
      class="mb-3"
      file-list
      label="Лист-оголошення про початок аудиту"
      main-folder="Аудит"
      @update:model-value="
        updateAuditDocuments('auditAnnouncement', $event)
      "></files-uploader>
    <files-uploader
      v-model="auditDTO.auditProgram"
      :name-folder="String(audit.id)"
      class="mb-3"
      file-list
      label="Програма аудиту"
      main-folder="Аудит"
      @update:model-value="
        updateAuditDocuments('auditProgram', $event)
      "></files-uploader>
    <files-uploader
      v-model="auditDTO.auditReport"
      :name-folder="String(audit.id)"
      class="mb-3"
      file-list
      label="Аудиторський звіт"
      main-folder="Аудит"
      @update:model-value="
        updateAuditDocuments('auditReport', $event)
      "></files-uploader>
    <files-uploader
      v-model="auditDTO.otherDocuments"
      :name-folder="String(audit.id)"
      file-list
      label="Робочі документи аудиту"
      main-folder="Аудит"
      @update:model-value="
        updateAuditDocuments('otherDocuments', $event)
      "></files-uploader>
  </div>
</template>

<script lang="ts">
import FilesUploader from '@/components/filesUploader/FilesUploader.vue'
import { useAudit } from '../index'

export default {
  name: 'Attachments',
  components: { FilesUploader },
  setup() {
    return { ...useAudit() }
  },
}
</script>

<style lang="scss" scoped></style>
